import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { NotificationManager } from "react-notifications";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { getMBMIotConnector, deleteMBMIotConnector } from "services/ConfigServices";
import useIotConnectorsTable from "./useIotConnectorsTable.js";
import IoTConnectorDialog from "./IoTConnectorDialog";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import UserService from "services/UserService";
import Button from "components/CustomButtons/Button.js";
import styled from "styled-components";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { iotconnectorstext } from "variables/MBM/iotconnectors";
import { serverTypeData, statusData } from "variables/MBM/lists/iotconnectors";
import Chip from "@mui/material/Chip";
import Dialog from "@mui/material/Dialog";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Menu, MenuItem } from "@mui/material";

const GroupCell = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;

const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem 4rem 2rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;

const ElementTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ElementData = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;


const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles = makeStyles(styles);

const RTIotConnectors = () => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const currentusertype = localStorage.getItem('userType');
  const mbm_admin = permis.includes("mbm_admin") && currentusertype==1; //not in prod yet
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  const [open, setOpen] = useState(false);
  const [currentIotconnector, setCurrentIotconnector] = useState(null);
  const { gridState, refetch, setIotconnectors } = useIotConnectorsTable();
  const [openMenu, setOpenMenu] = React.useState(null);

  const handleClickMenu = (event, row) => {
    let obj = dataIotconnectors.find((o) => o.id === row.id);
    if (obj) {
      setCurrentIotconnector(obj);
      setOpenMenu(event.currentTarget);
    }

  };
  const handleCloseMenu = (event) => {
    setOpenMenu(null);
  }

  let dataIotconnectors = gridState.data;

  const classes = useStyles();

  const columns = [
    {
      name: iotconnectorstext.name,
      selector: (row) => row.name,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.name,
    },
    {
      name: iotconnectorstext.servertype,
      selector: (row) => row.servertype,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => serverTypeData.find((x) => x.id == row.servertype)?.name || ""
    },
    {
      name: iotconnectorstext.organizationid,
      selector: (row) => row.connectionproperties?.organizationid,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => row.connectionproperties?.organizationid
    },
    {
      name: iotconnectorstext.nameonserver,
      selector: (row) => row.nameonserver,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.nameonserver,
    },
    {
      name: iotconnectorstext.status,
      selector: (row) => row.status,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => statusData.find((x) => x.id == row.status)?.name || ""
    },
    {
      name: iotconnectorstext.group,
      selector: (row) => row.groupid,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => groupInfoListById["" + row.groupid] || ""
    },
    {
      name: "Actions",
      sortable: false,
      width: "10rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            {currentusertype == 1 && (
              <>
                <Tooltip title="Editer le connecteur">
                  <Button
                    onClick={editIotconnector(row)}
                    color={"warning"}
                    className={classes.actionButton}
                  >
                    <EditIcon fontSize="large" />
                  </Button>
                </Tooltip>
                <Tooltip title="Supprimer le connecteur">
                  <CustomDeleteButton
                    deleteTitle={"Suppression du connecteur"}
                    deleteSubTitle={`Êtes-vous sûr de vouloir supprimer le connecteur ${row.name}?`}
                    handleSupprimer={deleteIotconnectorFunction(row)}
                  />
                </Tooltip>
              </>
            )}
            {mbm_admin && (
              <Tooltip title="Plus d'actions">
                <Button
                  onClick={(event) => handleClickMenu(event, row)}
                  color={"transparent"}
                  className={classes.actionButton}
                  justIcon={true}
                >
                  <MoreHorizIcon fontSize="large" />
                </Button>
              </Tooltip>
            )}
          </div>
        </>
      ),
    },
  ];

  const handleTestConnection = () => {
    setOpenMenu(null);
    let url = getMBMIotConnector(currentIotconnector.id, "test");
    axios
      .get(url,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
      .then((res) => {
        if (res.status == 200) {
          let test = res.data;
          if (res.data.status === 1) {
            setNotification(
              "success",
              `Organisation détectée : ` + res.data.message
            );
          }
          else {
            setNotification(
              "error",
              statusData.find((x) => x.id == res.data.status)?.name
            );
          }
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  }

  const handleGetGateways = () => {
    setOpenMenu(null);
    let url = getMBMIotConnector(currentIotconnector.id, "gateways");
    axios
      .get(url,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
      .then((res) => {
        if (res.status == 200) {
          let test = res.data;
          if (res.data.status === 1) {
            setNotification(
              "success",
              `Gateways récupérées : ` + res.data.count +
              `. Gateways mises à jour : ` + res.data.updated +
              `. Gateways créées : ` + res.data.inserted
            );
          }
          else {
            setNotification(
              "error",
              statusData.find((x) => x.id == res.data.status)?.name
            );
          }
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  }

  const handleGetDevices = () => {
    setOpenMenu(null);
    let url = getMBMIotConnector(currentIotconnector.id, "devices");
    axios
      .get(url,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
      .then((res) => {
        if (res.status == 200) {
          let test = res.data;
          if (res.data.status === 1) {
            setNotification(
              "success",
              `Devices récupérées : ` + res.data.count +
              `. Devices mises à jour : ` + res.data.updated +
              `. Devices créées : ` + res.data.inserted
            );
          }
          else {
            setNotification(
              "error",
              statusData.find((x) => x.id == res.data.status)?.name
            );
          }
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  }

  const handleGetDeviceProfiles = () => {
    setOpenMenu(null);
    let url = getMBMIotConnector(currentIotconnector.id, "deviceprofiles");
    axios
      .get(url,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
      .then((res) => {
        if (res.status == 200) {
          let test = res.data;
          if (res.data.status === 1) {
            setNotification(
              "success",
              `Profils récupérées : ` + res.data.count +
              `. Profils mises à jour : ` + res.data.updated +
              `. Profils créées : ` + res.data.inserted
            );
          }
          else {
            setNotification(
              "error",
              statusData.find((x) => x.id == res.data.status)?.name
            );
          }
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  }

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleEditClose = () => {
    setOpen(false);
  };

  const editIotconnector = (row) => async () => {
    let obj = dataIotconnectors.find((o) => o.id === row.id);
    if (obj) {
      setCurrentIotconnector(obj);
      handleClickOpen();
    }
  }

  const deleteIotconnectorFunction = (row) => async () => {
    let obj = dataIotconnectors.find((o) => o.id === row.id);
    let idSelected = obj.id;
    let url = deleteMBMIotConnector(idSelected);
    axios
      .delete(url,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
      .then((res) => {
        if (res.status == 200) {
          setNotification(
            "success",
            `Le connecteur a été supprimé`
          );
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const handleSelectedRowsChange = (selection) => {
    setIotconnectors(selection.selectedRows);
  };


  return (
    <>
      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        noDataComponent={<NoData>Aucun connecteur à afficher</NoData>}
        noHeader={true}
        columns={columns}
        persistTableHead
        pagination
        subHeader
        onSelectedRowsChange={handleSelectedRowsChange}
        selectableRows={true}
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        expandableRowDisabled={(row) => row.disabled}
        paginationComponentOptions={{
          noRowsPerPage: false,
          rowsPerPageText: "Lignes par page",
          rangeSeparatorText: "sur",
          selectAllRowsItem: false,
          selectAllRowsItemText: "Selectionner toutes les lignes",
        }}
        {...gridState}
      />
      <Dialog
        onClose={handleEditClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="sm"
        open={open}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleEditClose}>
          Modification de connecteur
        </CustomDialogTitle>
        <DialogContent dividers>
          <IoTConnectorDialog
            currentConnector={currentIotconnector}
            closeModal={handleEditClose}
            refetch={refetch}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Menu
        id="chart-menu"
        className={"chart-menu"}
        anchorEl={openMenu}
        keepMounted
        aria-haspopup={'menu'}
        open={Boolean(openMenu)}
        onClose={handleCloseMenu}
      >
        <MenuItem onClick={handleTestConnection} key={`handleTestConnection`}>
          Tester le connecteur
        </MenuItem>
        {currentIotconnector?.servertype === 'avoblorawanserver' ?
          <MenuItem onClick={handleGetGateways} key={`handleGetGateways`}>
            Récupérer les gateways
          </MenuItem>
          : <></>
        }
        {currentIotconnector?.servertype === 'avoblorawanserver' ?
          <MenuItem onClick={handleGetDeviceProfiles} key={`handleGetDeviceProfiles`}>
            Récupérer les profils de device
          </MenuItem>
          : <></>
        }
        <MenuItem onClick={handleGetDevices} key={`handleGetDevices`}>
          Récupérer les devices IoT
        </MenuItem>
        
      </Menu>
    </>
  );
};

export default RTIotConnectors;
